import React from 'react'

import OutboundFullKegShipmentHistoryForm from '../OutboundFullKegShipmentHistory/Form'
import Table from './Table'

import {
  HISTORY_FORM_NAME_KEG_FILLS,
} from '../../../../constants'


const formReducerName = HISTORY_FORM_NAME_KEG_FILLS

export default props => (
  <div>
    <OutboundFullKegShipmentHistoryForm // CODE_COMMENTS_93
      formReducerName={formReducerName}
      kegFillsHistoryFormRatherThanOutboundShipmentsHistoryForm
      {...props}
    />
    <Table
      formReducerName={formReducerName}
      {...props}
    />
  </div>
)
